export const DEFAULT_ACTION_PREFIX = 'KARNOTT_BEACONS';
export const DEFAULT_SERVICE_NAME = 'beacons';
export const DEFAULT_ACCESSOR_CHAIN = [DEFAULT_SERVICE_NAME];
